module.exports = __webpack_public_path__ + "static/coverus-93aa8c4e3b5913481a8bca517aa541a0.png";